import { Component, Input, ViewEncapsulation, OnDestroy } from '@angular/core';
import { IdService } from '../../shared/services/id.service';
import { TButtonSize } from '../button/button.types';
import { TButtonToggleType } from './button-toggle-container.types';

@Component({
	selector: 'rbc-toggle-container',
	templateUrl: './button-toggle-container.component.html',
	styleUrls: ['./button-toggle-container.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class ButtonToggleContainerComponent implements OnDestroy {
	@Input() color: TButtonToggleType;
	@Input() id: string;
	@Input() size: TButtonSize;

	constructor(private idService: IdService) {
		this.id = idService.generate();
		this.color = 'primary';
		this.size = 'small';
	}

	ngOnDestroy(): void {
		this.idService.remove(this.id);
	}

	classGen() {
		return {
			[`toggle-${this.size}`]: this.size && (this.size === 'large' || this.size === 'small'),
			[`toggle-${this.color}`]: this.color
		};
	}
}
